import { render, staticRenderFns } from "./ChangePasswordPopUp.vue?vue&type=template&id=fae5a1d2&scoped=true"
import script from "./ChangePasswordPopUp.vue?vue&type=script&lang=js"
export * from "./ChangePasswordPopUp.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordPopUp.vue?vue&type=style&index=0&id=fae5a1d2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae5a1d2",
  null
  
)

export default component.exports